import { Routes, Route, Link } from "react-router-dom";
import MainLayout from "@/components/layout/MainLayout";
import { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { API } from "@/App";
import axios from "axios";
import { toast } from "sonner";
import { FileText, Camera, ClipboardList, Plus, ArrowUpRight } from "lucide-react";

function DashboardHome() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API}/dashboard/stats`);
      setStats(response.data);
    } catch (error) {
      toast.error("Erro ao carregar dados");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-luvcorp-navy"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="operational-dashboard">
      {/* Quick Actions - Mobile Optimized */}
      <div className="grid grid-cols-2 gap-4">
        <Link to="/daily-logs/new">
          <Card className="border-0 shadow-sm hover:shadow-md transition-shadow cursor-pointer h-full">
            <CardContent className="p-6 flex flex-col items-center justify-center text-center">
              <div className="h-16 w-16 bg-luvcorp-gold/10 rounded-full flex items-center justify-center mb-4">
                <Plus className="h-8 w-8 text-luvcorp-gold" />
              </div>
              <p className="font-semibold text-luvcorp-navy">Novo RDO</p>
              <p className="text-xs text-slate-500 mt-1">Registro Diário</p>
            </CardContent>
          </Card>
        </Link>
        
        <Link to="/daily-logs">
          <Card className="border-0 shadow-sm hover:shadow-md transition-shadow cursor-pointer h-full">
            <CardContent className="p-6 flex flex-col items-center justify-center text-center">
              <div className="h-16 w-16 bg-luvcorp-navy/10 rounded-full flex items-center justify-center mb-4">
                <FileText className="h-8 w-8 text-luvcorp-navy" />
              </div>
              <p className="font-semibold text-luvcorp-navy">Meus Registros</p>
              <p className="text-xs text-slate-500 mt-1">{stats?.total_daily_logs || 0} registros</p>
            </CardContent>
          </Card>
        </Link>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 gap-4">
        <Card className="border-0 shadow-sm">
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-slate-500 mb-1">Tarefas Atribuídas</p>
                <p className="text-2xl font-bold text-luvcorp-navy">{stats?.total_service_orders || 0}</p>
              </div>
              <ClipboardList className="h-10 w-10 text-luvcorp-gold" />
            </div>
            <Link to="/service-orders" className="flex items-center gap-1 text-sm text-luvcorp-gold mt-4 hover:underline">
              Ver tarefas <ArrowUpRight className="h-4 w-4" />
            </Link>
          </CardContent>
        </Card>
      </div>

      {/* Instructions */}
      <Card className="border-0 shadow-sm bg-luvcorp-navy/5">
        <CardHeader className="pb-2">
          <CardTitle className="text-base font-heading text-luvcorp-navy">Como usar</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="flex items-start gap-3">
            <div className="h-6 w-6 bg-luvcorp-gold rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-xs font-bold text-white">1</span>
            </div>
            <p className="text-sm text-slate-600">Clique em "Novo RDO" para criar um registro diário de obra</p>
          </div>
          <div className="flex items-start gap-3">
            <div className="h-6 w-6 bg-luvcorp-gold rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-xs font-bold text-white">2</span>
            </div>
            <p className="text-sm text-slate-600">Adicione fotos e informações técnicas sobre os materiais utilizados</p>
          </div>
          <div className="flex items-start gap-3">
            <div className="h-6 w-6 bg-luvcorp-gold rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-xs font-bold text-white">3</span>
            </div>
            <p className="text-sm text-slate-600">A equipe de engenharia irá aprovar seu registro</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default function OperationalDashboard() {
  return (
    <MainLayout>
      <Routes>
        <Route index element={<DashboardHome />} />
      </Routes>
    </MainLayout>
  );
}
